(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /**
   * Cart popup behaviour. Progressive enhancement over a working cart:
   *   • opens from the header cart icon (and after any /cart/add form submits),
   *   • +/- and Remove call /cart/change.js,
   *   • every request asks for this section back and swaps the body in,
   *   • the header count badge is kept in sync.
   * On any network failure it falls back to a normal navigation / submit.
   */
  (function () {
    var SECTION = 'cart-drawer';

    function money(el) { return el; }

    function init() {
      var pop = document.querySelector('[data-cartpop]');
      if (!pop || pop.dataset.cartReady === 'true') return;
      pop.dataset.cartReady = 'true';

      var modal = pop.querySelector('.cartpop__modal');
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        pop.hidden = false;
        // Next frame so the entrance transition runs.
        requestAnimationFrame(function () { pop.setAttribute('data-open', ''); });
        document.body.style.overflow = 'hidden';
        if (modal) modal.focus();
      }

      function close() {
        pop.removeAttribute('data-open');
        document.body.style.overflow = '';
        var done = function () {
          pop.hidden = true;
          pop.removeEventListener('transitionend', done);
        };
        pop.addEventListener('transitionend', done);
        // Fallback in case transitionend doesn't fire.
        setTimeout(function () { if (!pop.hasAttribute('data-open')) pop.hidden = true; }, 400);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      function setBusy(on) { pop.classList.toggle('is-busy', on); }

      function updateHeaderCount(count) {
        var badge = document.querySelector('[data-cart-count]');
        if (!badge) return;
        var n = parseInt(count, 10) || 0;
        badge.textContent = n;
        if (n > 0) badge.removeAttribute('hidden');
        else badge.setAttribute('hidden', '');
      }

      function render(html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cartpop-body]');
        var cur = pop.querySelector('[data-cartpop-body]');
        if (next && cur) cur.innerHTML = next.innerHTML;
        var root = doc.querySelector('[data-cartpop]');
        if (root) updateHeaderCount(root.getAttribute('data-cart-count'));
      }

      function change(key, qty) {
        setBusy(true);
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty, sections: SECTION })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.sections) render(data.sections[SECTION]);
            setBusy(false);
          })
          .catch(function () {
            setBusy(false);
            window.location = '/cart';
          });
      }

      // ---- Open triggers ----
      var toggle = document.querySelector('[data-cart-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          open();
        });
      }

      // ---- Delegated controls inside the popup ----
      pop.addEventListener('click', function (event) {
        if (event.target.closest('[data-cartpop-close]')) {
          event.preventDefault();
          close();
          return;
        }
        var ctrl = event.target.closest('[data-cartpop-change]');
        if (ctrl) {
          event.preventDefault();
          change(ctrl.getAttribute('data-key'), parseInt(ctrl.getAttribute('data-qty'), 10));
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && pop.hasAttribute('data-open')) close();
      });

      // ---- Add to cart: intercept any /cart/add form ----
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || form.getAttribute('action') == null) return;
        if (!/\/cart\/add$/.test(form.getAttribute('action'))) return;

        event.preventDefault();
        var data = new FormData(form);
        data.append('sections', SECTION);
        setBusy(true);

        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data
        })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (res) {
            setBusy(false);
            if (!res.ok) {
              // e.g. sold out — let the normal form flow handle/report it.
              form.submit();
              return;
            }
            if (res.body && res.body.sections) render(res.body.sections[SECTION]);
            open();
          })
          .catch(function () {
            setBusy(false);
            form.submit();
          });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('[data-cartpop]')) init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /**
   * Collection filtering behaviour. The markup already works as a plain GET
   * form; this layer adds:
   *   • instant apply on desktop (submit as soon as a filter changes),
   *   • the mobile filter drawer (open/close, overlay, Escape, scroll lock),
   *   • sort applying on change.
   * Active filters, URLs, pagination and back/forward all come "for free" from
   * standard navigation, so nothing here manages history.
   */
  (function () {
    function initCollection(root) {
      if (root.dataset.collReady === 'true') return;
      root.dataset.collReady = 'true';
      root.classList.add('is-enhanced');

      var form = root.querySelector('[data-facet-form]');
      if (!form) return;

      var panel = root.querySelector('[data-filter-panel]');
      var overlay = root.querySelector('[data-filter-overlay]');
      var openBtn = root.querySelector('[data-filter-open]');
      var closeBtn = root.querySelector('[data-filter-close]');
      var desktop = window.matchMedia('(min-width: 64rem)');

      // ---- Apply on change ----
      form.addEventListener('change', function (event) {
        var el = event.target;
        if (el.matches('[data-sort]')) {
          form.submit();
          return;
        }
        // Filter inputs auto-apply on desktop; on mobile they wait for Apply.
        if (el.matches('.filter__check, .pricefield__input') && desktop.matches) {
          form.submit();
        }
      });

      // Enter inside a price field submits, matching a filter click.
      form.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && event.target.matches('.pricefield__input')) {
          event.preventDefault();
          form.submit();
        }
      });

      // ---- Mobile drawer ----
      if (panel && openBtn) {
        var open = function () {
          panel.setAttribute('data-open', '');
          if (overlay) {
            overlay.hidden = false;
            // Next frame so the opacity transition runs.
            requestAnimationFrame(function () { overlay.setAttribute('data-open', ''); });
          }
          openBtn.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
        };

        var close = function () {
          panel.removeAttribute('data-open');
          if (overlay) {
            overlay.removeAttribute('data-open');
            var hide = function () {
              overlay.hidden = true;
              overlay.removeEventListener('transitionend', hide);
            };
            overlay.addEventListener('transitionend', hide);
          }
          openBtn.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        };

        openBtn.addEventListener('click', open);
        if (closeBtn) closeBtn.addEventListener('click', close);
        if (overlay) overlay.addEventListener('click', close);

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && panel.hasAttribute('data-open')) close();
        });

        // Leaving mobile width tidies up any open-drawer state.
        var onChange = function (event) {
          if (event.matches) close();
        };
        if (desktop.addEventListener) desktop.addEventListener('change', onChange);
      }
    }

    function init() {
      document.querySelectorAll('[data-collection]').forEach(initCollection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-collection]');
      if (root) initCollection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Header: swaps the transparent overlay for a solid white bar once the
   * customer scrolls off the top. One passive listener coalesced into a single
   * rAF, writing a class only when the state actually changes.
   */
  (function () {
    function initHeader() {
      var header = document.querySelector('[data-np-header]');
      if (!header) return;

      var ticking = false;
      var was = null;

      function apply() {
        ticking = false;
        var scrolled = (window.scrollY || window.pageYOffset || 0) > 60;
        if (scrolled === was) return;
        was = scrolled;
        header.classList.toggle('is-stuck', scrolled);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      apply();
    }

    function initDrawer() {
      var drawer = document.querySelector('[data-np-drawer]');
      if (!drawer) return;

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer.open) {
          drawer.open = false;
          var toggle = drawer.querySelector('summary');
          if (toggle) toggle.focus();
        }
      });

      drawer.addEventListener('click', function (event) {
        if (event.target.closest('a')) drawer.open = false;
      });

      var desktop = window.matchMedia('(min-width: 78.0625rem)');
      if (desktop.addEventListener) {
        desktop.addEventListener('change', function (event) {
          if (event.matches) drawer.open = false;
        });
      }
    }

    function init() {
      initHeader();
      initDrawer();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('[data-np-header]')) init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-scene"] && !Shopify.designMode) return;
  try {
    
  /**
   * Hero drift. Writes a single custom property (--p, 0 → 1) as the hero
   * leaves the viewport; all motion is CSS from there. Skipped entirely on
   * small screens and under reduced motion.
   */
  (function () {
    function initHero(hero) {
      if (!hero || hero.dataset.npReady === 'true') return;
      hero.dataset.npReady = 'true';
      if (hero.dataset.animate === 'false') return;

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var small = window.matchMedia('(max-width: 48rem)');
      var frameId = null;
      var running = false;
      var visible = true;
      var last = -1;

      function frame() {
        frameId = null;
        var rect = hero.getBoundingClientRect();
        var p = rect.height > 0 ? -rect.top / rect.height : 0;
        p = p < 0 ? 0 : p > 1 ? 1 : p;

        if (last < 0 || Math.abs(p - last) > 0.0005) {
          last = p;
          hero.style.setProperty('--p', p.toFixed(4));
        }

        if (running) frameId = window.requestAnimationFrame(frame);
      }

      function start() {
        if (running || reduced.matches || small.matches || document.hidden || !visible) return;
        running = true;
        frame();
      }

      function stop() {
        running = false;
        if (frameId) window.cancelAnimationFrame(frameId);
        frameId = null;
      }

      function apply() {
        if (reduced.matches || small.matches) {
          stop();
          hero.style.removeProperty('--p');
        } else {
          start();
        }
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            visible = entries[0].isIntersecting;
            if (visible) start();
            else stop();
          },
          { rootMargin: '10% 0px' }
        ).observe(hero);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      if (reduced.addEventListener) reduced.addEventListener('change', apply);
      if (small.addEventListener) small.addEventListener('change', apply);
      apply();
    }

    function init() {
      document.querySelectorAll('[data-np-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var hero = event.target.querySelector('[data-np-hero]');
      if (hero) initHero(hero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  /**
   * Klaviyo list subscription. Only runs when the section has both a Klaviyo
   * public key and a list id (otherwise the Shopify fallback form is used and
   * this does nothing). Posts the email to Klaviyo's client subscriptions API
   * — the public key is meant for browser use — then swaps the input row for
   * the success message. Consent / double opt-in and de-duplication are handled
   * by Klaviyo based on the list's settings.
   */
  (function () {
    var REVISION = '2024-10-15';

    function initForm(form) {
      if (form.dataset.klReady === 'true') return;
      form.dataset.klReady = 'true';

      var key = form.getAttribute('data-kl-key');
      var list = form.getAttribute('data-kl-list');
      var row = form.querySelector('[data-kl-row]');
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('[data-kl-submit]');
      var okEl = form.querySelector('[data-kl-success]');
      var errEl = form.querySelector('[data-kl-error]');
      if (!key || !list || !input) return;

      function fail() {
        if (btn) btn.disabled = false;
        if (errEl) {
          errEl.textContent = 'Sorry, something went wrong. Please try again.';
          errEl.hidden = false;
        }
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var email = (input.value || '').trim();
        if (!email || (input.checkValidity && !input.checkValidity())) {
          if (input.reportValidity) input.reportValidity();
          return;
        }

        if (errEl) errEl.hidden = true;
        if (btn) btn.disabled = true;

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: REVISION },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Noble Pedal Newsletter',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        })
          .then(function (r) {
            if (r.status === 202 || r.ok) {
              if (row) row.hidden = true;
              if (okEl) okEl.hidden = false;
            } else {
              fail();
            }
          })
          .catch(fail);
      });
    }

    function init() {
      document.querySelectorAll('[data-kl-form]').forEach(initForm);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('[data-kl-form]')) init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  /**
   * FAQ accordion. Rows render collapsed; clicking a question toggles it. The
   * expand/collapse animation is pure CSS (grid-template-rows), so this only
   * flips aria-expanded — which both drives the CSS and keeps it accessible.
   */
  (function () {
    function initFaq(root) {
      root.querySelectorAll('.faq__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!open));
        });
      });
    }

    /**
     * After a successful contact submission Shopify lands on ?contact_posted=true
     * and keeps showing the confirmation. Strip that from the URL so refreshing
     * returns the empty form, ready to send another message. The already-rendered
     * confirmation stays on screen — only the address bar is tidied.
     */
    function tidyContactUrl() {
      if (!document.querySelector('[data-contact-success]')) return;
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }

    function init() {
      document.querySelectorAll('[data-faq]').forEach(initFaq);
      tidyContactUrl();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('[data-faq]')) init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Product carousel. The rail scrolls natively (touch swipe / trackpad) with
   * no script. This layer adds: mouse click-and-drag scrolling, the overlay
   * arrow buttons (revealed only on pointer screens with something to scroll),
   * and a per-card scroll on each arrow press. An arrow fades out once the rail
   * reaches its end.
   */
  (function () {
    function initCarousel(section) {
      var rail = section.querySelector('[data-pcar-rail]');
      var track = section.querySelector('[data-pcar-track]');
      if (!rail || !track) return;

      var prev = section.querySelector('[data-pcar-prev]');
      var next = section.querySelector('[data-pcar-next]');
      var item = track.querySelector('[data-pcar-item]');
      if (!item) return;

      var fine = window.matchMedia('(min-width: 48rem)');

      function step() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function overflows() {
        return track.scrollWidth - track.clientWidth > 4;
      }

      function sync() {
        var show = fine.matches && overflows();
        if (prev) prev.hidden = !show;
        if (next) next.hidden = !show;
        if (!show) return;
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(sync);
      }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      if (fine.addEventListener) fine.addEventListener('change', sync);

      // ---- Mouse click-and-drag ----
      // Touch already scrolls natively, so only hijack a primary mouse press.
      var down = false;
      var moved = false;
      var startX = 0;
      var startLeft = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        down = true;
        moved = false;
        startX = event.clientX;
        startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', function (event) {
        if (!down) return;
        var dx = event.clientX - startX;
        if (Math.abs(dx) > 5) moved = true;
        track.scrollLeft = startLeft - dx;
      });

      function endDrag() {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      // Suppress the click that follows a genuine drag, so letting go over a
      // card does not open the product.
      track.addEventListener('click', function (event) {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      }, true);

      sync();
    }

    function init() {
      document.querySelectorAll('.pcar').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.pcar');
      if (section) initCarousel(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  /**
   * Product page behaviour: gallery staging, variant readouts, accordions.
   *
   * The markup is usable without any of this — the form posts a real variant
   * id, every slide is in the DOM, and the accordions render open. This layer
   * only adds staging, live price/stock text and collapsing.
   */
  (function () {
    function initGallery(root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      if (slides.length < 2) return;

      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var index = 0;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        thumbs.forEach(function (thumb, i) {
          var active = i === index;
          thumb.classList.toggle('is-active', active);
          if (active) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          show(i);
        });
      });

      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });

      // Exposed so choosing a colour can stage that variant's image.
      root.showSlide = show;

      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') show(index - 1);
        if (event.key === 'ArrowRight') show(index + 1);
      });
    }

    function initVariants(scope) {
      var dataEl = scope.querySelector('[data-variant-data]');
      var priceEl = scope.querySelector('[data-price]');
      var stockEl = scope.querySelector('[data-stock]');
      var atc = scope.querySelector('[data-atc]');
      var atcText = scope.querySelector('[data-atc-text]');
      if (!dataEl || !priceEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var idInput = scope.querySelector('[data-variant-id-input]');

      scope.addEventListener('change', function (event) {
        var input = event.target.closest('input[data-option-index]');
        if (!input) return;

        // Gather the selected value for every option, then find the variant
        // whose options match all of them.
        var chosen = [];
        scope.querySelectorAll('input[data-option-index]:checked').forEach(function (el) {
          chosen[parseInt(el.dataset.optionIndex, 10)] = el.value;
        });

        var match = variants.filter(function (v) {
          return (v.options || []).every(function (val, i) {
            return val === chosen[i];
          });
        })[0];

        // Reflect the chosen value next to its label even if the combination
        // does not exist.
        var valueEl = scope.querySelector('[data-option-value="' + input.dataset.optionIndex + '"]');
        if (valueEl) valueEl.textContent = input.value;

        if (!match) {
          if (atc) {
            atc.disabled = true;
            if (atcText) atcText.textContent = 'Unavailable';
          }
          if (stockEl) {
            stockEl.classList.add('stock--out');
            var missing = stockEl.querySelector('.stock__text');
            if (missing) missing.textContent = 'Unavailable';
          }
          return;
        }

        if (idInput) idInput.value = match.id;

        // Wrap the currency symbol so it keeps the substituted glyph.
        function withCurrency(money) {
          return String(money).replace(/^([^\d]+)/, '<span class="buybox__cur">$1</span>');
        }

        var html = '<span class="buybox__price-now' + (match.onSale > 0 ? ' buybox__price-now--sale' : '') + '">' + withCurrency(match.price) + '</span>';
        if (match.onSale > 0 && match.compare) {
          html += '<s class="buybox__price-was">' + withCurrency(match.compare) + '</s>';
        }
        priceEl.innerHTML = html;

        if (stockEl) {
          stockEl.classList.toggle('stock--out', !match.available);
          var text = stockEl.querySelector('.stock__text');
          if (text) text.textContent = match.available ? 'In stock' : 'Out of stock';
        }

        if (atc) {
          atc.disabled = !match.available;
          if (atcText) atcText.textContent = match.available ? 'Add to cart' : 'Sold out';
        }

        // Stage the image Shopify has assigned to this variant, if any.
        var pos = parseInt(match.media || 0, 10);
        var gallery = scope.querySelector('[data-gallery]');
        if (pos > 0 && gallery && typeof gallery.showSlide === 'function') {
          gallery.showSlide(pos - 1);
        }
      });
    }

    function initQuantity(scope) {
      var input = scope.querySelector('#product-quantity');
      if (!input) return;

      function step(by) {
        var min = parseInt(input.min || '1', 10);
        var value = parseInt(input.value || String(min), 10);
        if (isNaN(value)) value = min;
        input.value = Math.max(min, value + by);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var down = scope.querySelector('[data-qty-down]');
      var up = scope.querySelector('[data-qty-up]');
      if (down) down.addEventListener('click', function () { step(-1); });
      if (up) up.addEventListener('click', function () { step(1); });
    }

    /**
     * Variant help popover. CSS already reveals it on hover for pointer
     * devices; this adds click/tap toggling, outside-click and Escape, and
     * keeps aria-expanded truthful. It never touches the radio inputs, so
     * variant selection is unaffected.
     */
    function initVariantInfo(scope) {
      var wrappers = Array.prototype.slice
        .call(scope.querySelectorAll('[data-vinfo-btn]'))
        .map(function (btn) {
          return btn.closest('.optgroup__label');
        })
        .filter(Boolean);
      if (!wrappers.length) return;

      function close(row) {
        row.removeAttribute('data-open');
        var btn = row.querySelector('[data-vinfo-btn]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }

      function closeAll() {
        wrappers.forEach(close);
      }

      wrappers.forEach(function (wrapper) {
        var btn = wrapper.querySelector('[data-vinfo-btn]');
        if (!btn) return;

        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var isOpen = wrapper.getAttribute('data-open') === 'true';
          closeAll();
          if (!isOpen) {
            wrapper.setAttribute('data-open', 'true');
            btn.setAttribute('aria-expanded', 'true');
          }
        });

        // Clicks inside the panel should not bubble out and close it.
        var panel = wrapper.querySelector('.vinfo__panel');
        if (panel) {
          panel.addEventListener('click', function (event) {
            event.stopPropagation();
          });
        }
      });

      document.addEventListener('click', closeAll);

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var open = wrappers.filter(function (w) {
          return w.getAttribute('data-open') === 'true';
        })[0];
        if (!open) return;
        close(open);
        var btn = open.querySelector('[data-vinfo-btn]');
        if (btn) btn.focus();
      });
    }

    function initViewing(scope) {
      var el = scope.querySelector('[data-viewing-count]');
      if (!el) return;
      // 6–18 inclusive, re-rolled on every page load.
      el.textContent = String(Math.floor(Math.random() * 13) + 6);
    }

    function initAccordions(root) {
      var triggers = Array.prototype.slice.call(root.querySelectorAll('.acc__trigger'));
      triggers.forEach(function (trigger, i) {
        // The rows render open so the content is present without JavaScript;
        // once scripting is available the first stays open and the rest close.
        // The panel animation is pure CSS, keyed off aria-expanded.
        trigger.setAttribute('aria-expanded', String(i === 0));

        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-gallery]').forEach(initGallery);
      if (document.querySelector('.pdp')) {
        initVariants(document);
        initQuantity(document);
        initViewing(document);
        initVariantInfo(document);
      }
      document.querySelectorAll('[data-accordions]').forEach(initAccordions);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('.pdp')) init();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
